import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyC8iY_UFfq2EzrQ-QNmjFqX2giRmLjsB0A",
  authDomain: "biba-website.firebaseapp.com",
  projectId: "biba-website",
  storageBucket: "biba-website.firebasestorage.app",
  messagingSenderId: "355202081119",
  appId: "1:355202081119:web:f0b3c3b45b40a17f4856ea",
  measurementId: "G-LWW7ESD9ZY"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, firebaseConfig };